import { render, staticRenderFns } from "./WorkerFormPage.vue?vue&type=template&id=0b2732a0&"
import script from "./WorkerFormPage.vue?vue&type=script&lang=js&"
export * from "./WorkerFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports